<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('documents')" :isFilter="false" :isColumns="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('documents')" :isFilter="false" :isColumns="false" />
            </template>
<!--            <div class="mb-2 border rounded p-2 text-center bg-dark text-white">-->
<!--                {{ user.student_number }} - {{ user.name }} {{ user.surname }}-->
<!--            </div>-->
            <b-row>
                <template v-for="(item, itemKey) in computeDocuments(user)">
                    <b-col cols="12" md="6" :key="'document' + itemKey" v-if="checkPermission(item.permission)">
                        <b-dropdown class="mb-2" block split split-variant="outline-dark" variant="dark" right
                                    :text="item.text.toUpper()">
                            <b-dropdown-item @click="item.callback(lang)"
                                             v-for="(lang, langKey) in item.language"
                                             :key="'lang' + langKey">
                                {{ $t(lang) }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </template>
            </b-row>
        </app-layout>
    </div>
</template>
<script>
import documentData from "@/modules/students/data/Documents";
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t("documents"),
        }
    },
    data() {
        return {
        }
    },
    computed:{
        user(){
            return this.$store.getters['auth/getUser'];
        }
    },
    methods: {
        computeDocuments(user) {
            let documents = [];
            if (this.user && this.user.id && this.user.student?.student_number) {
                if (user.registration_type == 212) {
                    documents = documentData(this.user).filter(
                        (document) => document.permission !== "studentdocument_militarystatus"
                    );
                } else {
                    documents = documentData(this.user);
                }
            }
            return documents;
        }


    }
}
</script>
